"use client";

import { useTranslation } from "@/src/i18n/client";
import { Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { ThemeToggle } from "@/src/components/ThemeToggle";

export function Footer() {
  const { t } = useTranslation();
  const [currentYear, setCurrentYear] = useState<number | null>(null);

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <footer>
      <div className="flex w-full flex-col md:flex-row items-center md:items-center justify-between gap-2 md:gap-4 py-2 md:pt-2">
        {/* Desktop: copyright first, then links and theme toggle */}
        <div className="w-full md:w-auto flex-1 order-3 md:order-1">
          <p className="text-center md:text-left text-xs sm:text-sm leading-loose text-gray-600 dark:text-gray-400 wrap-break-word">
            {currentYear !== null && t('footer.copyright', { year: currentYear })}
          </p>
        </div>
        <div className="w-full md:w-auto flex flex-row flex-wrap items-center justify-center md:justify-end gap-1 md:gap-0 order-2 md:order-2">
          <div className="flex flex-row flex-wrap items-center justify-center gap-1 md:gap-0">
            <Link to="/" search={{ force: true }} className="hidden md:inline px-2 md:px-3 text-xs sm:text-sm text-center whitespace-nowrap text-muted-foreground hover:text-foreground">
              {t('footer.start')}
            </Link>
            <span className="hidden md:inline text-border">|</span>
            <Link to="/terms" className="px-2 md:px-3 text-xs sm:text-sm text-center whitespace-nowrap text-muted-foreground hover:text-foreground">
              <span className="md:hidden">{t('footer.termsShort')}</span>
              <span className="hidden md:inline">{t('footer.terms')}</span>
            </Link>
            <span className="hidden md:inline text-border">|</span>
            <Link to="/privacy" className="px-2 md:px-3 text-xs sm:text-sm text-center whitespace-nowrap text-muted-foreground hover:text-foreground">
              <span className="md:hidden">{t('footer.privacyShort')}</span>
              <span className="hidden md:inline">{t('footer.privacy')}</span>
            </Link>
            <span className="hidden md:inline text-border">|</span>
            <Link to="/legal" className="px-2 md:px-3 text-xs sm:text-sm text-center whitespace-nowrap text-muted-foreground hover:text-foreground">
              <span className="md:hidden">{t('footer.legal')}</span>
              <span className="hidden md:inline">{t('footer.legalNotice')}</span>
            </Link>
          </div>
          <span className="ml-1 md:ml-2 flex items-center" style={{ fontSize: "0.7rem" }}>
            <ThemeToggle className="scale-75" />
          </span>
        </div>
      </div>
    </footer>
  );
}
